import React, { Component } from "react";
import AuthService from "./authService";


const AuthContext = React.createContext({
    signinRedirectCallback: () => ({}),
    logout: () => ({}),
    signoutRedirectCallback: () => ({}),
    isAuthenticated: () => ({}),
    signinRedirect: () => ({}),
    signinSilentCallback: () => ({}),
    createSigninRequest: () => ({}),
});

export const AuthConsumer = AuthContext.Consumer;
export const Auth = AuthContext;

export class AuthProvider extends Component {
    authService: any;
    props: any;
    constructor(props: any) {
        super(props);
        this.authService = new AuthService();
        this.props = props;
    }
    render() {
        return (
            <AuthContext.Provider value={this.authService} >
                {this.props.children}
            </AuthContext.Provider>
        );
    }
}
